<template>
  <FilterParent v-model="showAdminUserFilters" module="Company">
    <template #filterContent>
      <v-row class="ma-0">
        <v-col cols="12" lg="6" class="pa-2">
          <MultiSelect
            hide-details="auto"
            :items="customerGroupList"
            label="Select Customer Group"
            clearable
            v-model="filterObject.customer_group"
          />
        </v-col>

        <v-col cols="12" lg="6" class="pa-2">
          <MultiSelect
            hide-details="auto"
            :items="paymentMethods"
            label="Select Payment Method"
            clearable
            v-model="filterObject.payment_method"
          />
        </v-col>

        <v-col cols="12" lg="6" class="pa-2">
          <MultiSelect
            hide-details="auto"
            :items="booleanValues"
            label="Be Wise Invoicing"
            clearable
            v-model="filterObject.be_wise_invoicing"
          />
        </v-col>
        <v-col cols="12" lg="6" class="pa-2">
          <MultiSelect
            hide-details="auto"
            :items="booleanValues"
            label="Is Special Customer"
            clearable
            v-model="filterObject.is_special"
          />
        </v-col>
        <v-col cols="12" lg="6" class="pa-2">
          <MultiSelect
            hide-details="auto"
            :items="booleanValues"
            label="Is Local"
            clearable
            v-model="filterObject.is_local"
          />
        </v-col>
        <v-col cols="12" lg="6" class="pa-2">
          <MultiSelect
            hide-details="auto"
            :items="booleanValues"
            label="Is Cross Border"
            clearable
            v-model="filterObject.is_cross_border"
          />
        </v-col>
        <v-col cols="12" lg="6" class="pa-2">
          <MultiSelect
            hide-details="auto"
            :items="booleanValues"
            label="VAT Applicability"
            clearable
            v-model="filterObject.vat_applicability"
          />
        </v-col>
      </v-row>
    </template>

    <template #filterAction>
      <v-btn
        depressed
        color="secondary"
        @click="$emit('resetFilters'), (showAdminUserFilters = false)"
      >
        Reset
      </v-btn>

      <v-btn
        color="primary"
        class="ml-4"
        depressed
        @click="$emit('applyFilters'), (showAdminUserFilters = false)"
      >
        Apply
      </v-btn>
    </template>
  </FilterParent>
</template>

<script>
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import FilterParent from "@/components/General/FilterParent.vue";

export default {
  components: {
    FilterParent,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    bindingObject: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      customerGroupList: [],
      paymentMethods: [],
      booleanValues: [
        {
          text: "Yes",
          value: "true",
        },
        {
          text: "No",
          value: "false",
        },
      ],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getCompanyOptions();
      }
    },
  },
  computed: {
    showAdminUserFilters: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    filterObject: {
      get() {
        return this.bindingObject;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    currentProfile() {
      let obj = JSON.parse(localStorage.getItem("userProfile"));
      if (!obj) {
        return null;
      } else {
        return obj;
      }
    },
  },
  methods: {
    getCompanyOptions() {
      this.$bus.$emit("showLoader", true);
      this.$api.company
        .getCompanyOptions()
        .then((res) => {
          this.paymentMethods = res.data.actions.POST.payment_method.choices.map(
            (obj) => {
              return { text: obj.display_name, value: obj.value };
            }
          );
          this.customerGroupList =
            res.data.actions.POST.customer_group.choices.map((obj) => {
              return { text: obj.display_name, value: obj.value };
            });

          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
